import { UpgradeModel } from "types";

import SENECA_HAVEN_UPGRADES from "./haven";
import SENECA_MERIDIAN_UPGRADES from "./meridian";
import SENECA_SHIPWORKS_UPGRADES from "./shipworks";
import SENECA_UNDERHAVEN_UPGRADES from "./underhaven";

const SENECA_UPGRADES: Record<string, UpgradeModel> = {
  ...SENECA_SHIPWORKS_UPGRADES,
  ...SENECA_HAVEN_UPGRADES,
  ...SENECA_UNDERHAVEN_UPGRADES,
  ...SENECA_MERIDIAN_UPGRADES,
};

export default SENECA_UPGRADES;
